webpackJsonp([0],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionDetail_vue__ = __webpack_require__(160);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2__ActionDetail_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__ActionDetail_vue__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'rule-detail',
    props: ['rule', 'remote'],
    data: function data() {
        return {
            methodlist: [{ value: '', label: '所有' }, { value: 'get', label: 'GET' }, { value: 'post', label: 'POST' }, { value: 'put', label: 'PUT' }, { value: 'patch', label: 'PATCH' }, { value: 'delete', label: 'DELETE' }]
        };
    },

    methods: {
        editDataFile: function editDataFile(entry) {
            this.$dc.requestEditDataFile(entry);
        },
        addAction: function addAction() {
            this.rule.actionList.push({
                type: "redirect",
                data: {
                    target: "",
                    dataId: '',
                    modifyResponseType: '',
                    callbackName: "",
                    cookieKey: "",
                    cookieValue: "",
                    headerKey: "",
                    headerValue: "",
                    modifyRequestScript: "",
                    modifyResponseScript: ""
                }
            });
        },
        deleteAction: function deleteAction(index) {
            this.rule.actionList.splice(index, 1);
        }
    }
});

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    saveFile: function saveFile(content) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/profile/savefile', content);
    },
    disableRule: function disableRule() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/profile/setRuleState');
    },
    enableRule: function enableRule() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/profile/setRuleState?rulestate=1');
    },
    disableHost: function disableHost() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/profile/setHostState');
    },
    enableHost: function enableHost() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/profile/setHostState?hoststate=1');
    },
    disableFilter: function disableFilter() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/profile/setFilterState');
    },
    enableFilter: function enableFilter() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/profile/setFilterState?filterstate=1');
    }
});

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionDetail_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f690682a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionDetail_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(312)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f690682a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f690682a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f690682a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_manager_components_configure_ProjectPath__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_manager_components_host_FileList__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_manager_components_host_EditHost__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_manager_components_host_CreateFile__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_manager_components_rule_FileList__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_manager_components_rule_EditRule__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_manager_components_rule_CreateFile__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_manager_components_data_DataList__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_manager_components_help_Install__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_manager_components_plugins__ = __webpack_require__(383);


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/projectpath', component: __WEBPACK_IMPORTED_MODULE_2_src_manager_components_configure_ProjectPath__["a" /* default */] }, { path: '/hostfilelist', component: __WEBPACK_IMPORTED_MODULE_3_src_manager_components_host_FileList__["a" /* default */] }, { path: '/edithost', component: __WEBPACK_IMPORTED_MODULE_4_src_manager_components_host_EditHost__["a" /* default */] }, { path: '/createhostfile', component: __WEBPACK_IMPORTED_MODULE_5_src_manager_components_host_CreateFile__["a" /* default */] }, { path: '/rulefilelist', component: __WEBPACK_IMPORTED_MODULE_6_src_manager_components_rule_FileList__["a" /* default */] }, { path: '/editrule', component: __WEBPACK_IMPORTED_MODULE_7_src_manager_components_rule_EditRule__["a" /* default */] }, { path: '/createrulefile', component: __WEBPACK_IMPORTED_MODULE_8_src_manager_components_rule_CreateFile__["a" /* default */] }, { path: '/datalist', component: __WEBPACK_IMPORTED_MODULE_9_src_manager_components_data_DataList__["a" /* default */] }, { path: '/helpinstall', component: __WEBPACK_IMPORTED_MODULE_10_src_manager_components_help_Install__["a" /* default */], alias: '/' }, { path: '/plugins', component: __WEBPACK_IMPORTED_MODULE_11_src_manager_components_plugins__["a" /* default */] }]
}));

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d88208a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(306)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d88208a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d88208a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d88208a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* unused harmony default export */ var _unused_webpack_default_export = ({
  saveFile: function saveFile(content) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/configure/savefile', content);
  }
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



var api = {
  getRemoteRuleFile: function getRemoteRuleFile(url) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/utils/download?url=' + encodeURIComponent(url));
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (api);

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_data_center__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_data_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_data_center__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_regenerator_runtime_runtime__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__iconfont_css__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_pcss__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_pcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_pcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css__);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_data_center___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});
document.addEventListener('keydown', function (e) {
  if ((event.ctrlKey || event.metaKey) && event.which == 83) {
    event.preventDefault();
    return false;
  }
}, true);

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




var api = {
    createFile: function createFile(name, description) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/host/create', {
            name: name,
            description: description
        });
    },
    getFileList: function getFileList() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/host/filelist');
    },
    deleteFile: function deleteFile(name) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/host/deletefile?name=' + name);
    },
    toggleFile: function toggleFile(name) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/host/togglefile?name=' + name);
    },
    getFileContent: function getFileContent(name) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/host/getfile?name=' + name);
    },
    saveFile: function saveFile(name, content) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/host/savefile?name=' + name, content);
    },
    importRemote: function importRemote(url) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/host/import?url=' + encodeURIComponent(url));
    }
};
api.debouncedUseFile = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (name, callback) {
    api.toggleFile(name).then(function (response) {
        callback(response);
    });
}, 500);
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





var api = {
  createFile: function createFile(name, description) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/rule/create', {
      name: name,
      description: description
    });
  },
  getFileList: function getFileList() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/rule/filelist');
  },
  deleteFile: function deleteFile(name) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/rule/deletefile?name=' + encodeURIComponent(name));
  },
  setFileCheckStatus: function setFileCheckStatus(name, checked) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/rule/setfilecheckstatus?name=' + name + '&checked=' + (checked ? 1 : 0));
  },
  getFileContent: function getFileContent(name) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/rule/getfile?name=' + name);
  },
  saveFile: function saveFile(name, content) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/rule/savefile?name=' + name, content);
  },
  updateFileInfo: function updateFileInfo(origin, _ref) {
    var name = _ref.name,
        description = _ref.description;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/rule/updatefileinfo/' + encodeURIComponent(origin), { name: name, description: description });
  },
  testRule: function testRule(content) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/rule/test', content);
  },
  getRemoteRuleFile: function getRemoteRuleFile(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/utils/getGitlabFile?url=' + encodeURIComponent(url));
  },
  getReferenceVar: function getReferenceVar(content) {
    var contentStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
    var reg = RegExp("<%=(.+?)%>", 'g');
    var result;
    var varObj = {};
    while ((result = reg.exec(contentStr)) != null) {
      varObj[__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.trim(result[1])] = 1;
    }
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(varObj);
  },
  importRemote: function importRemote(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/rule/import?url=' + encodeURIComponent(url));
  },
  copyFile: function copyFile(name) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/rule/copy?name=' + encodeURI(name));
  },
  setFileDisableSync: function setFileDisableSync(name, disable) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/rule/setfiledisablesync?name=' + name + '&disable=' + (disable ? 1 : 0));
  }
};

api.debouncedSaveFile = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (name, content, callback) {
  api.saveFile(name, content).then(function (response) {
    callback(response);
  });
}, 3000);
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftMenu_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a7f02ba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftMenu_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(302)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a7f02ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a7f02ba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftMenu_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a7f02ba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftMenu_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectPath_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103b5c68_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectPath_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectPath_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103b5c68_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectPath_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103b5c68_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectPath_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataList_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3baae9de_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataList_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(316)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3baae9de_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3baae9de_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Install_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06803900_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Install_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(317)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Install_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06803900_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Install_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06803900_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Install_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateFile_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dae098b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFile_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dae098b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dae098b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHost_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde25c84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHost_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(310)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dde25c84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde25c84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHost_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde25c84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHost_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileList_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ad46f5f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileList_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(313)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ad46f5f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ad46f5f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e50977c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(304)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e50977c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e50977c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e50977c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plugin_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02454c80_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plugin_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(296)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02454c80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plugin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02454c80_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plugin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02454c80_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plugin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f8806cd_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(308)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f8806cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f8806cd_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f8806cd_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateFile_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ecbcbaa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFile_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ecbcbaa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ecbcbaa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRule_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0c5a10_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRule_vue__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(307)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e0c5a10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0c5a10_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRule_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0c5a10_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRule_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRuleConfigDialog_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6877e4be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRuleConfigDialog_vue__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRuleConfigDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6877e4be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRuleConfigDialog_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6877e4be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRuleConfigDialog_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRuleDialog_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf70d44a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRuleDialog_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(309)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf70d44a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRuleDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf70d44a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRuleDialog_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf70d44a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRuleDialog_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileList_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90907570_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileList_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(318)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90907570_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90907570_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RuleDetail_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad907918_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RuleDetail_vue__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(319)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RuleDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad907918_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RuleDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad907918_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RuleDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin grid",class:{deleted: _vm.isDeleted},on:{"click":_vm.toPlugin}},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.plugin.name))]),_vm._v(" "),_c('span',{staticClass:"version"},[_vm._v(_vm._s(_vm.plugin.version))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('p',{staticClass:"description"},[_vm._v("\n      "+_vm._s(_vm.plugin.description)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('el-dropdown',{on:{"command":_vm.onSetDisabled}},[_c('el-button',{attrs:{"type":"primary","icon":"setting"},on:{"click":function (e) { return e.stopPropagation(); }}},[_vm._v("\n        "+_vm._s(_vm.disabledText)+"\n      ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":false}},[_vm._v("\n          启用"),(!_vm.plugin.disabled)?_c('i',{staticClass:"el-icon-check icon-checked"}):_vm._e()]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":true}},[_vm._v("\n          禁用"),(_vm.plugin.disabled)?_c('i',{staticClass:"el-icon-check icon-checked"}):_vm._e()])],1)],1),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","icon":"delete"},on:{"click":_vm.onDelete}},[_vm._v("\n      卸载\n    ")])],1)])}
var staticRenderFns = []


/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"install-body"},[_vm._m(0),_vm._v(" "),_c('h2',{attrs:{"id":"toc_0"}},[_vm._v("一、说明")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h2',{attrs:{"id":"toc_1"}},[_vm._v("二、chrome 插件安装")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h4',{attrs:{"id":"toc_2"}},[_vm._v("插件使用说明")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h2',{attrs:{"id":"toc_3"}},[_vm._v("三、证书安装")]),_vm._v(" "),_c('h4',{attrs:{"id":"toc_4"}},[_vm._v("1. 为什么需要安装证书")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h4',{attrs:{"id":"toc_5"}},[_vm._v("2. 证书下载")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("mac 系统请"),_c('a',{attrs:{"href":_vm.url}},[_vm._v("点击下载到本地安装")])]),_vm._v(" "),_c('li',[_vm._v("手机请扫码安装证书"),_c('img',{staticClass:"install-body__qrcode",attrs:{"src":_vm.imgUrl}})]),_vm._v(" "),_vm._m(6)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Cy Proxy"),_c('a',{staticClass:"quick-start"},[_vm._v("快速开始")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("由于"),_c('code',[_vm._v("cyProxy")]),_vm._v("默认不修改系统代理设置，所以在 chrome 上使用代理功能时需要依赖第三方 chrome 插件。")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('code',[_vm._v("cyProxy")]),_vm._v("依赖 openssl 生成证书，使用 proxy 前请先安装 openssl (版本建议在 0.9.8 以上)。")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("推荐安装 SwitchyOmega "),_c('a',{attrs:{"href":"https://chrome.google.com/webstore/detail/proxy-switchyomega/padekgcemlokbadohgkifijomclgjgif?hl=en-US","target":"_blank"}},[_vm._v("点击安装代理插件")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("安装完插件后请设置插件代理地址为"),_c('code',[_vm._v("127.0.0.1")]),_vm._v("，代理协议: http，端口为"),_c('code',[_vm._v("cyProxy")]),_vm._v("代理端口(默认8001)。")]),_vm._v(" "),_c('li',[_vm._v("如不清楚如何配置 SwitchyOmega，请参考 "),_c('a',{attrs:{"href":"/help/chrome/","download":"cyProxy","target":"_blank"}},[_vm._v("chrome 代理设置指南")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("由于"),_c('code',[_vm._v("cyProxy")]),_vm._v("需要转发 /mock https 的请求，所以需要本地安装"),_c('code',[_vm._v("ZanMock-proxy")]),_vm._v("https 证书。")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._v("证书信任请参考"),_c('a',{attrs:{"href":"https://youzan.github.io/zan-proxy/book/quick-start/cert.html","target":"_blank"}},[_vm._v("如何信任证书")])])}]


/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-content__title"},[_vm._v("创建Host文件")]),_vm._v(" "),_c('el-form',{ref:"ruleForm",staticClass:"demo-ruleForm",staticStyle:{"margin":"20px","width":"60%","min-width":"600px"},attrs:{"model":_vm.createFileForm,"rules":_vm.rules,"label-width":"100px"}},[_c('el-form-item',{attrs:{"label":"文件名字","prop":"name"}},[_c('el-input',{model:{value:(_vm.createFileForm.name),callback:function ($$v) {_vm.$set(_vm.createFileForm, "name", $$v)},expression:"createFileForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"文件描述","prop":"description"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.createFileForm.description),callback:function ($$v) {_vm.$set(_vm.createFileForm, "description", $$v)},expression:"createFileForm.description"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('ruleForm')}}},[_vm._v("立即创建")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.back}},[_vm._v("返回")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-content__title"},[_vm._v("工程路径管理")]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px"},attrs:{"gutter":20}},[_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"span":6,"offset":18}},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.saveFile}},[_vm._v("保存工程路径设置")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.addParam}},[_vm._v("增加工程路径设置")])],1)],1),_vm._v(" "),_c('el-table',{attrs:{"border":"","align":"center","data":_vm.$dc.projectPathArray}},[_c('el-table-column',{attrs:{"type":"index","width":"60"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"key","label":"工程名","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"small","placeholder":"请输入工程名"},model:{value:(scope.row.key),callback:function ($$v) {_vm.$set(scope.row, "key", $$v)},expression:"scope.row.key"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"工程路径"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"small","placeholder":"请输入工程路径"},model:{value:(scope.row.value),callback:function ($$v) {_vm.$set(scope.row, "value", $$v)},expression:"scope.row.value"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":136,"context":_vm._self},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"danger","icon":"delete","size":"mini"},on:{"click":function($event){_vm.deleteParam(scope.row,scope.$index,_vm.projectPathArray)}}})]}}])})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-content__title"},[_vm._v("自定义数据文件列表")]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px"},attrs:{"gutter":20}},[_c('el-col',{staticClass:"addhost-btn-wrap",attrs:{"span":6,"offset":18}},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.$dc.requestAddDataFile()}}},[_vm._v("新增数据文件")])],1)],1),_vm._v(" "),_c('el-table',{attrs:{"border":"","align":"center","data":_vm.$dc.dataList}},[_c('el-table-column',{attrs:{"prop":"name","label":"名字","align":"center","width":"300","sortable":true}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contenttype","label":"类型","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":136,"align":"center","context":_vm._self},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"info","icon":"edit","size":"mini"},on:{"click":function($event){_vm.$dc.requestEditDataFile(scope.row)}}}),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","icon":"delete","size":"mini"},on:{"click":function($event){_vm.$dc.deleteDataFile(scope.row, scope.$index )}}})]}}])})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-menu"},[_c('h2',[_vm._v("Cy Proxy")]),_vm._v(" "),_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"theme":"dark","default-active":_vm.defaultActive},on:{"select":_vm.handleSelect}},[_vm._l((_vm.menuList),function(item,index){return [_c('div',{key:index},[(item.children)?_c('el-submenu',{attrs:{"index":index + ''}},[_c('template',{slot:"title"},[_c('i',{staticClass:"iconfont",class:item.icon}),_vm._v(" "),_c('span',{staticClass:"menu-name"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_vm._l((item.children),function(child,cindex){return _c('el-menu-item',{key:cindex,style:({'padding-left':'40px'}),attrs:{"index":index+"-"+cindex}},[_c('i',{staticClass:"iconfont",class:child.icon}),_vm._v(" "),_c('span',{staticClass:"menu-name"},[_vm._v("\n              "+_vm._s(child.name)+"\n            ")])])})],2):_c('el-menu-item',{attrs:{"index":index + ''}},[_c('i',{staticClass:"iconfont",class:item.icon}),_vm._v(" "),_c('span',{staticClass:"menu-name"},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])])],1)]})],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-content__title"},[_vm._v("创建规则集")]),_vm._v(" "),_c('el-form',{ref:"ruleForm",staticClass:"demo-ruleForm",staticStyle:{"margin":"20px","width":"60%","min-width":"600px"},attrs:{"model":_vm.createFileForm,"rules":_vm.rules,"label-width":"100px"}},[_c('el-form-item',{attrs:{"label":"规则集名字","prop":"name"}},[_c('el-input',{model:{value:(_vm.createFileForm.name),callback:function ($$v) {_vm.$set(_vm.createFileForm, "name", $$v)},expression:"createFileForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"规则集描述","prop":"description"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.createFileForm.description),callback:function ($$v) {_vm.$set(_vm.createFileForm, "description", $$v)},expression:"createFileForm.description"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.submitForm('ruleForm')}}},[_vm._v("立即创建")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.back()}}},[_vm._v("返回")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-btn grid",on:{"click":_vm.showDialog}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('el-dialog',{attrs:{"title":"添加插件","visible":_vm.dialogVisible,"size":"tiny","modal-append-to-body":true,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{attrs:{"model":_vm.plugin}},[_c('el-form-item',{attrs:{"label":"包名","label-width":_vm.formLabelWidth}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"插件包名"},model:{value:(_vm.plugin.name),callback:function ($$v) {_vm.$set(_vm.plugin, "name", $$v)},expression:"plugin.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"registry","label-width":_vm.formLabelWidth}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"https://registry.npmjs.org/"},model:{value:(_vm.plugin.registry),callback:function ($$v) {_vm.$set(_vm.plugin, "registry", $$v)},expression:"plugin.registry"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.hideDialog}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"编辑","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.cancel}},[_c('el-form',[_c('el-form-item',{attrs:{"label":"规则集名称","label-width":"120px"}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"规则集描述","label-width":"120px"}},[_c('el-input',{attrs:{"type":"textarea","auto-complete":"off"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.cancel}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.ok(_vm.name, _vm.description)}}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('header',{staticClass:"head-nav"},[_c('span',{staticClass:"dropdown-label"},[_vm._v("Host 设置：")]),_vm._v(" "),_c('el-dropdown',{attrs:{"menu-align":"start","hide-on-click":false},on:{"command":_vm.selectHostFile}},[_c('el-button',{attrs:{"type":"text"}},[_vm._v("\n                "+_vm._s(_vm.hostState ? _vm.selectedHost.join('，') : '禁用')),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.profile.enableHost)?_c('el-dropdown-item',{attrs:{"command":"__disabled__"}},[_vm._v("\n                    禁用\n                ")]):_vm._e(),_vm._v(" "),(!_vm.profile.enableHost)?_c('el-dropdown-item',{attrs:{"command":"__enabled__"}},[_vm._v("\n                    启用\n                ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.hostFileList),function(hostfile){return _c('el-dropdown-item',{attrs:{"command":hostfile.name,"disabled":!_vm.profile.enableHost}},[_vm._v("\n                    "+_vm._s(hostfile.name)+"\n                    "),(hostfile.checked)?_c('i',{staticClass:"el-icon-check"}):_vm._e()])})],2)],1),_vm._v(" "),_c('span',{staticClass:"dropdown-label"},[_vm._v("请求转发：")]),_vm._v(" "),_c('el-dropdown',{attrs:{"hide-on-click":false,"menu-align":"start"},on:{"command":_vm.selectRuleFile}},[_c('el-button',{attrs:{"type":"text"}},[_vm._v("\n                "+_vm._s(_vm.ruleState ? _vm.selectedRuleFiles.join('，') : '禁用')),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.profile.enableRule)?_c('el-dropdown-item',{attrs:{"command":"__disabled__"}},[_vm._v("\n                    禁用\n                ")]):_vm._e(),_vm._v(" "),(!_vm.profile.enableRule)?_c('el-dropdown-item',{attrs:{"command":"__enabled__"}},[_vm._v("\n                    启用\n                ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.ruleFileList),function(rulefile){return _c('el-dropdown-item',{attrs:{"command":rulefile.name + '-%-' + rulefile.checked,"disabled":!_vm.profile.enableRule}},[_vm._v("\n                    "+_vm._s(rulefile.name)+"\n                    "),(rulefile.checked)?_c('i',{staticClass:"el-icon-check"}):_vm._e()])})],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"left-fixed-right-auto"},[_c('div',{staticClass:"left"},[_c('left-menu')],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"main-content"},[_c('router-view')],1)])]),_vm._v(" "),_c('el-dialog',{ref:"mockDataDialg",attrs:{"title":"Mock数据文件","close-on-click-modal":false},model:{value:(_vm.mockDataFileForm.visible),callback:function ($$v) {_vm.$set(_vm.mockDataFileForm, "visible", $$v)},expression:"mockDataFileForm.visible"}},[_c('el-form',{attrs:{"model":_vm.addDataFileForm,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"名称"}},[_c('el-input',{model:{value:(_vm.mockDataFileForm.name),callback:function ($$v) {_vm.$set(_vm.mockDataFileForm, "name", $$v)},expression:"mockDataFileForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"格式"}},[_c('el-select',{attrs:{"placeholder":"请选择数据文件格式"},model:{value:(_vm.mockDataFileForm.contenttype),callback:function ($$v) {_vm.$set(_vm.mockDataFileForm, "contenttype", $$v)},expression:"mockDataFileForm.contenttype"}},[_c('el-option',{attrs:{"label":"html","value":"text/html"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"json","value":"application/json"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"javascript","value":"application/javascript"}})],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"height":"305px"},attrs:{"id":"content-editor-container"}},[_c('div',{attrs:{"id":"content-editor"}})]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.mockDataFileForm.visible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.formatEditor}},[_vm._v("格式化")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveMockData}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-content__title"},[_vm._v("编辑规则集"+_vm._s(_vm.loaded ? ': ' + (_vm.filecontent.name || '拼命加载中') : ': 拼命加载中'))]),_vm._v(" "),(_vm.loaded && _vm.filecontent.meta && _vm.filecontent.meta.remote)?_c('span',{staticClass:"save-tip"},[_vm._v("该规则集为远程规则集，重启同步后相关配置会被覆盖。如需永久保存修改，则可以复制该规则集成本地规则集。")]):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px","text-align":"right"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6,"offset":18}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.openEditRuleInfoDialog}},[_vm._v("编辑名字/描述")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.addRule}},[_vm._v("新增规则")])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","row-key":"key","stripe":true,"align":"center","data":_vm.filecontent.content}},[_c('el-table-column',{attrs:{"prop":"checked","label":"启用","align":"center","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"勾选后启动这条规则","placement":"left"}},[_c('el-checkbox',{on:{"change":_vm.saveFileRightNow},model:{value:(scope.row.checked),callback:function ($$v) {_vm.$set(scope.row, "checked", $$v)},expression:"scope.row.checked"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"请求方法","width":100},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.method)?_c('span',[_vm._v(_vm._s(scope.row.method))]):_c('span',[_vm._v("所有")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"match","label":"URL特征"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"描述"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"转发地址"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.actionList.filter(function (a) { return a.type === 'redirect'; })[0] ? scope.row.actionList.filter(function (a) { return a.type === 'redirect'; })[0].data.target : '--')+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":240,"align":"center","context":_vm._self},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"actions-container"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"编辑","placement":"left"}},[_c('el-button',{attrs:{"icon":"edit","size":"mini","type":"primary"},on:{"click":function($event){_vm.dialogEdit(scope.row.key)}}})],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"删除","placement":"top"}},[_c('el-button',{attrs:{"type":"danger","icon":"delete","size":"mini"},on:{"click":function($event){_vm.onDeleteRow(scope.row,scope.$index,_vm.filecontent.content)}}})],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"复制","placement":"left"}},[_c('el-button',{attrs:{"icon":"document","size":"mini"},on:{"click":function($event){_vm.onDuplicateRow(scope.row,scope.$index,_vm.filecontent.content)}}})],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"测试规则","placement":"left"}},[_c('el-button',{attrs:{"type":"blue","icon":"search","size":"mini"},on:{"click":function($event){_vm.testMatchRuleRequest(scope.row)}}})],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"提高优先级","placement":"left"}},[_c('el-button',{attrs:{"type":"blue","icon":"caret-top","size":"mini","disabled":scope.$index === 0},on:{"click":function($event){_vm.onMoveUpRule(scope.$index)}}})],1)],1)]}}])})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"匹配规则测试(只测试正则匹配，不包含请求方法)","size":"large"},model:{value:(_vm.testMatchRuleFormVisible),callback:function ($$v) {_vm.testMatchRuleFormVisible=$$v},expression:"testMatchRuleFormVisible"}},[_c('el-form',{attrs:{"model":_vm.testMatchRuleForm,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"请求url"}},[_c('el-input',{model:{value:(_vm.testMatchRuleForm.url),callback:function ($$v) {_vm.$set(_vm.testMatchRuleForm, "url", $$v)},expression:"testMatchRuleForm.url"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"匹配条件"}},[_c('el-input',{model:{value:(_vm.testMatchRuleForm.match),callback:function ($$v) {_vm.$set(_vm.testMatchRuleForm, "match", $$v)},expression:"testMatchRuleForm.match"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"转发路径"}},[_c('el-input',{model:{value:(_vm.testMatchRuleForm.targetTpl),callback:function ($$v) {_vm.$set(_vm.testMatchRuleForm, "targetTpl", $$v)},expression:"testMatchRuleForm.targetTpl"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"匹配结果"}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.testMatchRuleForm.matchRlt),callback:function ($$v) {_vm.$set(_vm.testMatchRuleForm, "matchRlt", $$v)},expression:"testMatchRuleForm.matchRlt"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"最终目标路径"}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.testMatchRuleForm.targetRlt),callback:function ($$v) {_vm.$set(_vm.testMatchRuleForm, "targetRlt", $$v)},expression:"testMatchRuleForm.targetRlt"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"其他信息"}},[_c('el-input',{attrs:{"type":"textarea","disabled":true},model:{value:(_vm.testMatchRuleForm.msg),callback:function ($$v) {_vm.$set(_vm.testMatchRuleForm, "msg", $$v)},expression:"testMatchRuleForm.msg"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.testMatchRuleFormVisible = false}}},[_vm._v("关 闭")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.testMatchRule}},[_vm._v("测 试")])],1)],1),_vm._v(" "),_c('edit-dialog',{attrs:{"visible":_vm.dialogVisible,"save":_vm.dialogSave,"cancel":_vm.hideEditDialog,"initRule":_vm.editingRule}}),_vm._v(" "),_c('edit-rule-config-dialog',{attrs:{"visible":_vm.editRuleConfigDialogVisible,"ok":_vm.updateFileInfo,"cancel":_vm.closeEditRuleNameDialog,"defaultName":_vm.filecontent.name,"defaultDescription":_vm.filecontent.description}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manager"},[_c('div',{staticClass:"title"},[_vm._v("插件管理")]),_vm._v(" "),_c('div',{staticClass:"grids"},[_vm._l((_vm.plugins),function(p){return _c('plugin',{key:p.name,attrs:{"plugin":p,"delete":_vm.deletePlugin,"setDisabled":_vm.setPluginDisabled}})}),_vm._v(" "),_c('add',{attrs:{"add":_vm.addPlugin}})],2)])}
var staticRenderFns = []


/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"host-view"},[_c('div',{staticClass:"main-content__title"},[_vm._v("Host 文件列表")]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px"},attrs:{"gutter":20}},[_c('el-col',{staticClass:"addhost-btn-wrap"},[_c('input',{ref:"fileimport",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.importHostFile}}),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.importHostFileBtnClick}},[_vm._v("导入 Host 文件")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.importRemoteHostFile}},[_vm._v("导入远程 Host 文件")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.addNewHostFile}},[_vm._v("新增 Host 文件")])],1)],1),_vm._v(" "),_c('el-table',{attrs:{"border":"","align":"center","data":_vm.$dc.hostFileList}},[_c('el-table-column',{attrs:{"prop":"checked","label":"启用","width":"85"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-checkbox',{attrs:{"checked":scope.row.checked,"disabled":!_vm.$dc.hostState},on:{"change":function($event){_vm.toggleFile(scope.row.name)}}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"名字","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"描述"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":136,"context":_vm._self},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":'#/edithost?name='+scope.row.name}},[_c('el-button',{attrs:{"type":"info","icon":"edit","size":"mini"}})],1),_vm._v(" "),_c('a',{attrs:{"href":'/host/download?name='+scope.row.name,"target":"_blank"}},[_c('el-button',{attrs:{"type":"info","icon":"share","size":"mini"}})],1),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","icon":"delete","size":"mini"},on:{"click":function($event){_vm.onDeleteFile(scope.row,scope.$index,_vm.user_list)}}})]}}])})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-content__title"},[_vm._v("规则集列表")]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px"},attrs:{"gutter":20}},[_c('el-col',{staticClass:"addrule-btn-wrap"},[_c('input',{staticClass:"importfile",attrs:{"type":"file"},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('el-button',{attrs:{"size":"small"}},[_vm._v("导入规则集")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.importRemoteRule}},[_vm._v("导入远程规则")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.addRuleCollection}},[_vm._v("新增规则集")])],1)],1),_vm._v(" "),_c('el-table',{attrs:{"border":"","data":_vm.$dc.ruleFileList}},[_c('el-table-column',{attrs:{"prop":"checked","label":"启用","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-checkbox',{attrs:{"disabled":!_vm.$dc.ruleState},on:{"change":function($event){_vm.onSelectionChange(scope.row.name,scope.row.checked)}},model:{value:(scope.row.checked),callback:function ($$v) {_vm.$set(scope.row, "checked", $$v)},expression:"scope.row.checked"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"名字","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.meta&&scope.row.meta.remote)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"远程规则","placement":"right"}},[_c('span',{staticClass:"file-tag remote"},[_vm._v("R")])]):_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"本地规则","placement":"right"}},[_c('span',{staticClass:"file-tag"},[_vm._v("L")])]),_vm._v("\n        "+_vm._s(scope.row.name)+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"描述"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":180,"context":_vm._self},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":'#/editrule?name='+scope.row.name}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"编辑规则","placement":"top-start"}},[_c('el-button',{attrs:{"type":"info","icon":"edit","size":"mini"}})],1)],1),_vm._v(" "),_c('span',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"导出规则","placement":"top-start"}},[_c('el-button',{attrs:{"type":"info","icon":"share","size":"mini"},on:{"click":function($event){_vm.onShareFile(scope.row,scope.$index)}}})],1)],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"复制规则","placement":"top-start"}},[_c('el-button',{attrs:{"type":"info","icon":"document","size":"mini"},on:{"click":function($event){_vm.onCopyFile(scope.row,scope.$index)}}})],1),_vm._v(" "),_c('span',[_c('el-button',{attrs:{"type":"danger","icon":"delete","size":"mini"},on:{"click":function($event){_vm.onDeleteFile(scope.row,scope.$index)}}})],1)]}}])})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('div',{staticClass:"el-form demo-form-inline el-form--inline conditon"},[_c('div',{staticClass:"el-form-item",staticStyle:{"margin-bottom":"8px"}},[_c('div',{staticClass:"el-form-item__content"},[_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small","placeholder":"请选择","disabled":_vm.remote},model:{value:(_vm.rule.method),callback:function ($$v) {_vm.$set(_vm.rule, "method", $$v)},expression:"rule.method"}},_vm._l((_vm.methodlist),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"el-form-item",staticStyle:{"margin-bottom":"8px","width":"calc(100% - 170px)","padding-left":"20px","margin-right":"0px"}},[_c('div',{staticClass:"el-form-item__content",staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small","disabled":_vm.remote,"placeholder":"填写要拦截的url中部分连续的字符串，或者匹配要拦截url的正则表达式"},model:{value:(_vm.rule.match),callback:function ($$v) {_vm.$set(_vm.rule, "match", $$v)},expression:"rule.match"}})],1)])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px 0"}},[_c('span',{staticStyle:{"width":"85%","display":"inline-block"}},[_c('div',[_c('el-input',{attrs:{"size":"small","placeholder":"规则说明，写一段文字，方便记忆这个规则的作用"},model:{value:(_vm.rule.name),callback:function ($$v) {_vm.$set(_vm.rule, "name", $$v)},expression:"rule.name"}})],1)]),_vm._v(" "),_c('span',{staticStyle:{"width":"10%","display":"inline-block"}},[_c('el-button',{attrs:{"type":"text","disabled":_vm.remote},on:{"click":_vm.addAction}},[_vm._v("新增动作")])],1)]),_vm._v(" "),_c('div',_vm._l((_vm.rule.actionList),function(action,index){return _c('div',{key:index,staticClass:"dashed-border"},[_c('span',{staticStyle:{"width":"85%","display":"inline-block"}},[_c('action-detail',{attrs:{"action":action,"remote":_vm.remote}})],1),_vm._v(" "),_c('span',{staticStyle:{"width":"10%","display":"inline-block","vertical-align":"bottom","line-height":"107px","height":"107px"}},[_c('el-button',{attrs:{"type":"text","disabled":_vm.remote},on:{"click":function($event){_vm.deleteAction(index)}}},[_vm._v("删除动作")])],1)])}))])}
var staticRenderFns = []


/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"编写规则","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.cancel}},[_c('el-form',{attrs:{"model":_vm.rule}},[_c('el-form-item',{attrs:{"label":"请求方法","label-width":_vm.formLabelWidth}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.rule.method),callback:function ($$v) {_vm.$set(_vm.rule, "method", $$v)},expression:"rule.method"}},_vm._l((_vm.methodlist),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"URL特征","label-width":_vm.formLabelWidth}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"填写要拦截的url中部分连续的字符串，或者匹配要拦截url的正则表达式"},model:{value:(_vm.rule.match),callback:function ($$v) {_vm.$set(_vm.rule, "match", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"rule.match"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"规则描述","label-width":_vm.formLabelWidth}},[_c('el-input',{attrs:{"auto-complete":"off","placeholder":"规则说明，写一段文字，方便记忆这个规则的作用"},model:{value:(_vm.rule.name),callback:function ($$v) {_vm.$set(_vm.rule, "name", $$v)},expression:"rule.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"请求动作","label-width":_vm.formLabelWidth}},[_vm._l((_vm.rule.actionList),function(action,index){return _c('div',{key:index,staticClass:"action-container"},[_c('action-detail',{attrs:{"action":action}}),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"删除","placement":"right"}},[_c('el-button',{attrs:{"type":"danger","icon":"minus","size":"mini"},on:{"click":function($event){_vm.removeAction(index)}}})],1)],1)}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"plus","size":"mini"},on:{"click":_vm.addAction}},[_vm._v("\n                添加请求动作\n            ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.cancel}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveRule}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-content__title"},[_vm._v("编辑Host文件"+_vm._s(_vm.loaded ? ': ' + _vm.filecontent.name : ''))]),_vm._v(" "),(_vm.loaded && _vm.filecontent.meta && !_vm.filecontent.meta.local)?_c('span',{staticClass:"save-tip"},[_vm._v("该Host文件为远程Host文件，重启同步后相关配置会被覆盖。如需永久保存修改，请新建Host文件。")]):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6,"offset":18}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.addRow}},[_vm._v("新增Host Entry")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.saveFile}},[_vm._v("保存文件")])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","align":"center","data":_vm.hostarray}},[_c('el-table-column',{attrs:{"type":"index","width":"60"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"key","label":"域名","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"small","placeholder":"请输入内容"},model:{value:(scope.row.key),callback:function ($$v) {_vm.$set(scope.row, "key", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"scope.row.key"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"ip地址","align":"center","width":"400"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"small","placeholder":"请输入内容"},model:{value:(scope.row.value),callback:function ($$v) {_vm.$set(scope.row, "value", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"scope.row.value"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":80,"align":"center","context":_vm._self},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"danger","icon":"delete","size":"mini"},on:{"click":function($event){_vm.onDeleteRow(scope.row,scope.$index,_vm.filecontent.content)}}})]}}])})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","flex":"1"}},[_c('div',{staticClass:"inline-block left-panel"},[_c('el-select',{staticStyle:{"margin-right":"10px","font-size":"12px"},attrs:{"placeholder":"请选择","size":"small","disabled":_vm.remote},model:{value:(_vm.action.type),callback:function ($$v) {_vm.$set(_vm.action, "type", $$v)},expression:"action.type"}},_vm._l((_vm.ruleType),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),(_vm.action.type == 'redirect')?_c('div',{staticClass:"inline-block right-panel"},[_c('div',{staticClass:"action-data"},[_c('el-input',{attrs:{"size":"small","disabled":_vm.remote,"placeholder":"远程地址(以http/https开头)、本地地址"},model:{value:(_vm.action.data.target),callback:function ($$v) {_vm.$set(_vm.action.data, "target", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"action.data.target"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.action.type == 'mockData'),expression:"action.type == 'mockData'"}],staticClass:"inline-block right-panel"},[_c('div',{staticClass:"action-data"},[_c('span',[_c('el-select',{staticStyle:{"width":"300px"},attrs:{"size":"small","filterable":"","placeholder":"请选择要返回的数据"},model:{value:(_vm.action.data.dataId),callback:function ($$v) {_vm.$set(_vm.action.data, "dataId", $$v)},expression:"action.data.dataId"}},_vm._l((_vm.$dc.dataList),function(dataentry){return _c('el-option',{key:dataentry.id,attrs:{"label":dataentry.name,"value":dataentry.id}})}))],1),_vm._v(" "),(_vm.datafileEntry)?_c('span',{staticStyle:{"margin-left":"10px"}},[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.editDataFile(_vm.datafileEntry)}}},[_vm._v("\n              编辑数据\n            ")])],1):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px"}},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.addDataFile}},[_vm._v("增加自定义数据")])],1)])]),_vm._v(" "),(_vm.action.type == 'addRequestCookie')?_c('div',{staticClass:"inline-block right-panel"},[_c('div',{staticClass:"action-data"},[_c('el-input',{staticStyle:{"display":"inline-block","width":"120px"},attrs:{"size":"small","disabled":_vm.remote,"placeholder":"cookie key"},model:{value:(_vm.action.data.cookieKey),callback:function ($$v) {_vm.$set(_vm.action.data, "cookieKey", $$v)},expression:"action.data.cookieKey"}}),_vm._v(" "),_c('el-input',{staticStyle:{"display":"inline-block","width":"300px"},attrs:{"size":"small","disabled":_vm.remote,"placeholder":"cookie value"},model:{value:(_vm.action.data.cookieValue),callback:function ($$v) {_vm.$set(_vm.action.data, "cookieValue", $$v)},expression:"action.data.cookieValue"}})],1)]):_vm._e(),_vm._v(" "),(_vm.action.type == 'modifyResponse')?_c('div',{staticClass:"inline-block right-panel"},[_c('div',{staticClass:"action-data"},[_c('el-select',{staticStyle:{"width":"260px"},attrs:{"size":"small","placeholder":"请选择修改返回body操作","disabled":_vm.remote},model:{value:(_vm.action.data.modifyResponseType),callback:function ($$v) {_vm.$set(_vm.action.data, "modifyResponseType", $$v)},expression:"action.data.modifyResponseType"}},_vm._l((_vm.modifyResponseType),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})})),_vm._v(" "),(_vm.action.data.modifyResponseType == 'returnDataInJsonpStyle')?_c('span',[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"size":"small","disabled":_vm.remote,"placeholder":"jsonp callback参数名"},model:{value:(_vm.action.data.callbackName),callback:function ($$v) {_vm.$set(_vm.action.data, "callbackName", $$v)},expression:"action.data.callbackName"}})],1):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.action.type == 'addRequestHeader')?_c('div',{staticClass:"inline-block right-panel"},[_c('div',{staticClass:"action-data"},[_c('el-input',{staticStyle:{"display":"inline-block","width":"120px"},attrs:{"size":"small","disabled":_vm.remote,"placeholder":"header key"},model:{value:(_vm.action.data.headerKey),callback:function ($$v) {_vm.$set(_vm.action.data, "headerKey", $$v)},expression:"action.data.headerKey"}}),_vm._v(" "),_c('el-input',{staticStyle:{"display":"inline-block","width":"120px"},attrs:{"size":"small","disabled":_vm.remote,"placeholder":"header value"},model:{value:(_vm.action.data.headerValue),callback:function ($$v) {_vm.$set(_vm.action.data, "headerValue", $$v)},expression:"action.data.headerValue"}})],1)]):_vm._e(),_vm._v(" "),(_vm.action.type == 'addResponseHeader')?_c('div',{staticClass:"inline-block right-panel"},[_c('div',{staticClass:"action-data"},[_c('el-input',{staticStyle:{"display":"inline-block","width":"120px"},attrs:{"size":"small","disabled":_vm.remote,"placeholder":"header key"},model:{value:(_vm.action.data.headerKey),callback:function ($$v) {_vm.$set(_vm.action.data, "headerKey", $$v)},expression:"action.data.headerKey"}}),_vm._v(" "),_c('el-input',{staticStyle:{"display":"inline-block","width":"120px"},attrs:{"size":"small","disabled":_vm.remote,"placeholder":"header value"},model:{value:(_vm.action.data.headerValue),callback:function ($$v) {_vm.$set(_vm.action.data, "headerValue", $$v)},expression:"action.data.headerValue"}})],1)]):_vm._e(),_vm._v(" "),(_vm.action.type == 'scriptModifyRequest')?_c('div',{staticClass:"inline-block right-panel"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.action.data.modifyRequestScript),expression:"action.data.modifyRequestScript"}],staticStyle:{"width":"500px","height":"90px"},domProps:{"value":(_vm.action.data.modifyRequestScript)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.action.data, "modifyRequestScript", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.action.type == 'scriptModifyResponse')?_c('div',{staticClass:"inline-block right-panel"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.action.data.modifyResponseScript),expression:"action.data.modifyResponseScript"}],staticStyle:{"width":"500px","height":"90px"},domProps:{"value":(_vm.action.data.modifyResponseScript)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.action.data, "modifyResponseScript", $event.target.value)}}})]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);




/* harmony default export */ __webpack_exports__["a"] = ({
  getDataList: function getDataList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/data/getdatalist');
  },
  saveDataList: function saveDataList(content) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/data/savedatalist', content);
  },
  getDataFile: function getDataFile(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/data/getdatafile?id=' + id);
  },
  saveDataFile: function saveDataFile(id, content) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/data/savedatafile?id=' + id, { content: content });
  },
  saveDataEntryFromTraffic: function saveDataEntryFromTraffic(reqId, name, contenttype) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/data/savedatafromtraffic', {
      id: __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()(),
      name: name,
      contenttype: contenttype,
      reqid: reqId
    });
  }
});

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_LeftMenu__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_host__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_rule__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_conf__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_profile__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_data__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_uuid_v4__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_codemirror__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_codemirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_codemirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_is_json__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_is_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_is_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_codemirror_lib_codemirror_css__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_codemirror_lib_codemirror_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_codemirror_lib_codemirror_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_codemirror_addon_display_fullscreen__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_codemirror_addon_display_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_codemirror_addon_display_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_codemirror_addon_display_fullscreen_css__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_codemirror_addon_display_fullscreen_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_codemirror_addon_display_fullscreen_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_codemirror_mode_javascript_javascript__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_codemirror_mode_javascript_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_codemirror_mode_javascript_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_codemirror_mode_htmlmixed_htmlmixed__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_codemirror_mode_htmlmixed_htmlmixed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_codemirror_mode_htmlmixed_htmlmixed__);
























var editor = null;
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_3__components_common_LeftMenu__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_common_LeftMenu__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            isDataCenter: true,

            configure: {},

            profile: {
                projectPath: [],
                enableRule: false
            },

            projectPathArray: [],

            mappedClientIps: [],

            rule: [],

            hostFileList: [],

            ruleFileList: [],
            filters: [],
            dataList: [],

            addDataFileForm: {
                visible: false,
                callback: null,
                id: '',
                name: '',
                contenttype: ''
            },

            editDataFileForm: {
                visible: false,
                entry: {},
                content: ''
            },
            mockDataFileForm: {
                isNew: true,
                visible: false,
                id: '',
                name: '',
                contenttype: '',
                content: '',
                callback: null
            }
        };
    },

    computed: {
        ruleState: function ruleState() {
            return this.profile.enableRule || false;
        },
        hostState: function hostState() {
            return this.profile.enableHost || false;
        },
        filterState: function filterState() {
            return this.profile.enableFilter || false;
        },
        selectedHost: function selectedHost() {
            return this.hostFileList.filter(function (h) {
                return h.checked;
            }).map(function (h) {
                return h.name;
            });
        },
        selectedRuleFiles: function selectedRuleFiles() {
            return this.ruleFileList.filter(function (f) {
                return f.checked;
            }).map(function (f) {
                return f.name;
            });
        }
    },
    methods: {
        switchHost: function switchHost(value) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.profile.enableHost) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].disableHost();

                            case 3:
                                _context.next = 7;
                                break;

                            case 5:
                                _context.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].enableHost();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        selectHostFile: function selectHostFile(command) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var name;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                name = command;

                                if (!(command === '__disabled__')) {
                                    _context2.next = 5;
                                    break;
                                }

                                _context2.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].disableHost();

                            case 4:
                                return _context2.abrupt('return', _context2.sent);

                            case 5:
                                if (!(command === '__enabled__')) {
                                    _context2.next = 9;
                                    break;
                                }

                                _context2.next = 8;
                                return __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].enableHost();

                            case 8:
                                return _context2.abrupt('return', _context2.sent);

                            case 9:
                                __WEBPACK_IMPORTED_MODULE_4__api_host__["a" /* default */].debouncedUseFile(name, function (response) {
                                    var serverData = response.data;
                                    if (serverData.code == 0) {
                                        _this2.$message({
                                            type: 'success',
                                            message: '设置成功!'
                                        });
                                    } else {
                                        _this2.$message.error('\u51FA\u9519\u4E86,\u8BF7\u5237\u65B0\u9875\u9762\uFF0C' + serverData.msg);
                                    }
                                });

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        switchFilter: function switchFilter(value) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (_this3.profile.enableFilter) {
                                    __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].disableFilter();
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].enableFilter();
                                }

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        switchRule: function switchRule(value) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (_this4.profile.enableRule) {
                                    __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].disableRule();
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].enableRule();
                                }

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        selectRuleFile: function selectRuleFile(command) {
            var _this5 = this;

            if (command === '__disabled__') {
                return __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].disableRule();
            }
            if (command === '__enabled__') {
                return __WEBPACK_IMPORTED_MODULE_7__api_profile__["a" /* default */].enableRule();
            }
            var kv = command.split('-%-');
            __WEBPACK_IMPORTED_MODULE_5__api_rule__["a" /* default */].setFileCheckStatus(kv[0], kv[1] == 'false').then(function (response) {
                var serverData = response.data;
                if (serverData.code != 0) {
                    _this5.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                }
            });
        },
        deleteDataFile: function deleteDataFile(entry, index) {
            var _this6 = this;

            this.$confirm('\u6B64\u64CD\u4F5C\u5C06\u6C38\u4E45\u5220\u9664\u8BE5\u6570\u636E\u6587\u4EF6: ' + entry.name + ', \u662F\u5426\u7EE7\u7EED?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this6.dataList.splice(index, 1);
                __WEBPACK_IMPORTED_MODULE_11__api_data__["a" /* default */].saveDataList(_this6.dataList).then(function (res) {
                    var serverData = res.data;
                    if (serverData.code == 0) {
                        _this6.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    } else {
                        _this6.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                    }
                });
            });
        },
        requestAddDataFile: function requestAddDataFile(cb) {
            this.showEditDataFileForm({}, true, cb);
        },
        addDataFile: function addDataFile() {
            var _this7 = this;

            this.addDataFileForm.visible = false;

            this.dataList.push({
                id: this.mockDataFileForm.id || __WEBPACK_IMPORTED_MODULE_12_uuid_v4___default()(),
                name: this.mockDataFileForm.name,
                contenttype: this.mockDataFileForm.contenttype
            });
            __WEBPACK_IMPORTED_MODULE_11__api_data__["a" /* default */].saveDataList(this.dataList).then(function (res) {
                var serverData = res.data;
                if (serverData.code == 0) {
                    _this7.$message({
                        type: 'success',
                        message: '新建成功!'
                    });
                    _this7.mockDataFileForm.name = '';
                    _this7.mockDataFileForm.contenttype = '';
                } else {
                    _this7.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                }
            });
        },
        toggleFullScreen: function toggleFullScreen() {
            if (editor.getOption('fullScreen')) {
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()('#content-editor').parents('.el-dialog').css('transform', '');
            } else {
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()('#content-editor').parents('.el-dialog').css('transform', 'initial');
            }
            editor.setOption('fullScreen', !editor.getOption('fullScreen'));
            editor.focus();
        },
        closeFullScreen: function closeFullScreen() {
            if (editor.getOption('fullScreen')) {
                editor.setOption('fullScreen', false);
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()('#content-editor').parents('.el-dialog').css('transform', '');

                editor.focus();
            }
        },
        formatEditor: function formatEditor() {
            try {
                if (!/json/i.test(this.mockDataFileForm.contenttype)) {
                    return;
                }
                var content = editor.getValue();
                var formated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(content), null, 4);
                editor.setValue(formated);
                editor.refresh();
                editor.focus();
            } catch (e) {
                this.$message.error('JSON格式错误，请检查');
            }
        },
        showEditDataFileForm: function showEditDataFileForm(entry, isNew, callback) {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var response, serverData;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this8.mockDataFileForm.isNew = isNew;
                                _this8.mockDataFileForm.id = entry.id || __WEBPACK_IMPORTED_MODULE_12_uuid_v4___default()();
                                _this8.mockDataFileForm.name = entry.name || '';
                                _this8.mockDataFileForm.contenttype = entry.contenttype || '';
                                _this8.mockDataFileForm.content = '';
                                _this8.mockDataFileForm.callback = callback;

                                if (isNew) {
                                    _context5.next = 15;
                                    break;
                                }

                                _context5.next = 9;
                                return __WEBPACK_IMPORTED_MODULE_11__api_data__["a" /* default */].getDataFile(_this8.mockDataFileForm.id);

                            case 9:
                                response = _context5.sent;
                                serverData = response.data;

                                if (!(serverData.code != 0)) {
                                    _context5.next = 14;
                                    break;
                                }

                                _this8.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                                return _context5.abrupt('return');

                            case 14:
                                _this8.mockDataFileForm.content = serverData.data;

                            case 15:
                                _this8.mockDataFileForm.visible = true;
                                if (editor) {
                                    editor.setValue(_this8.mockDataFileForm.content);
                                    editor.setOption('mode', _this8.mockDataFileForm.contenttype);
                                    _this8.$nextTick(function () {
                                        editor.refresh();
                                        editor.focus();
                                    });
                                } else {
                                    _this8.$nextTick(function () {
                                        window.$ = __WEBPACK_IMPORTED_MODULE_9_jquery___default.a;
                                        window.editor = editor = new __WEBPACK_IMPORTED_MODULE_13_codemirror___default.a(document.getElementById('content-editor'), {
                                            value: _this8.mockDataFileForm.content,
                                            mode: _this8.mockDataFileForm.contenttype,
                                            lineNumbers: true,
                                            matchBrackets: true,
                                            autofocus: true
                                        });
                                    });
                                }

                            case 17:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this8);
            }))();
        },
        requestEditDataFile: function requestEditDataFile(entry, cb) {
            this.showEditDataFileForm(entry, false, cb);
        },
        finishEditDataFile: function finishEditDataFile() {
            var _this9 = this;

            var entry = this.editDataFileForm.entry;
            if (entry.contenttype.includes('json')) {
                try {
                    JSON.parse(editor.getValue());
                } catch (error) {
                    this.$message.error('JSON格式错误，请检查');
                    return;
                }
            }
            __WEBPACK_IMPORTED_MODULE_11__api_data__["a" /* default */].saveDataFile(entry.id, editor.getValue()).then(function (response) {
                var serverData = response.data;
                if (serverData.code == 0) {
                    _this9.$message({
                        type: 'success',
                        message: '保存成功!'
                    });
                    _this9.editDataFileForm.entry = {};
                    _this9.editDataFileForm.visible = false;
                    editor.setValue('');
                } else {
                    _this9.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                }
            });
        },
        saveMockData: function saveMockData() {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (_this10.mockDataFileForm.name) {
                                    _context6.next = 3;
                                    break;
                                }

                                _this10.$message.error('请填写名字');
                                return _context6.abrupt('return');

                            case 3:
                                if (_this10.mockDataFileForm.contenttype) {
                                    _context6.next = 6;
                                    break;
                                }

                                _this10.$message.error('请选择格式');
                                return _context6.abrupt('return');

                            case 6:
                                if (!_this10.mockDataFileForm.contenttype.includes('json')) {
                                    _context6.next = 15;
                                    break;
                                }

                                _context6.prev = 7;

                                JSON.parse(editor.getValue());
                                _context6.next = 15;
                                break;

                            case 11:
                                _context6.prev = 11;
                                _context6.t0 = _context6['catch'](7);

                                _this10.$message.error('JSON格式错误，请检查');
                                return _context6.abrupt('return');

                            case 15:
                                if (!_this10.mockDataFileForm.isNew) {
                                    _context6.next = 19;
                                    break;
                                }

                                _this10.dataList.push({
                                    id: _this10.mockDataFileForm.id,
                                    name: _this10.mockDataFileForm.name,
                                    contenttype: _this10.mockDataFileForm.contenttype
                                });
                                _context6.next = 19;
                                return __WEBPACK_IMPORTED_MODULE_11__api_data__["a" /* default */].saveDataList(_this10.dataList);

                            case 19:
                                __WEBPACK_IMPORTED_MODULE_11__api_data__["a" /* default */].saveDataFile(_this10.mockDataFileForm.id, editor.getValue()).then(function (response) {
                                    var serverData = response.data;
                                    if (serverData.code == 0) {
                                        _this10.$message({
                                            type: 'success',
                                            message: '保存成功!'
                                        });
                                        _this10.mockDataFileForm.callback && _this10.mockDataFileForm.callback(_this10.mockDataFileForm.id);
                                        _this10.mockDataFileForm.name = '';
                                        _this10.mockDataFileForm.id = null;
                                        _this10.mockDataFileForm.contenttype = '';
                                        _this10.mockDataFileForm.content = '';
                                        _this10.mockDataFileForm.visible = false;
                                        _this10.mockDataFileForm.callback = null;
                                        editor.setValue('');
                                    } else {
                                        _this10.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                                    }
                                });

                            case 20:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this10, [[7, 11]]);
            }))();
        }
    },

    created: function created() {
        var _this11 = this;

        if (!window.io) return;
        var socket = io('/manager');

        socket.on('configure', function (data) {
            _this11.configure = data;
        });

        socket.on('profile', function (profile) {
            _this11.profile = profile;
            var result = [];
            __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.forEach(profile.projectPath, function (value, key) {
                result.push({
                    key: key,
                    value: value
                });
            });
            _this11.projectPathArray = result;
        });

        socket.on('mappedClientIps', function (ips) {
            _this11.mappedClientIps = ips;
        });

        socket.on('hostfilelist', function (data) {
            _this11.hostFileList = data;
        });

        socket.on('rulefilelist', function (data) {
            _this11.ruleFileList = data;
        });

        socket.on('filters', function (data) {
            _this11.filters = data;
        });

        socket.on('datalist', function (data) {
            _this11.dataList = data;
        });
    },
    mounted: function mounted() {
        this.$refs.mockDataDialg.rendered = true;
    },


    watch: {
        profile: function profile() {
            if (this.profile.enableHost && this.selectedHost) {
                document.title = this.selectedHost + ' - Cy Proxy';
            } else {
                document.title = 'Cy Proxy';
            }
        },
        selectedHost: function selectedHost() {
            if (this.profile.enableHost && this.selectedHost) {
                document.title = this.selectedHost + ' - Cy Proxy';
            } else {
                document.title = 'Cy Proxy';
            }
        },

        'mockDataFileForm.contenttype': function mockDataFileFormContenttype(newValue) {
            if (editor) {
                editor.setOption('mode', newValue);
            }
        }
    }
});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var menuList = [{
  name: '使用说明',
  icon: 'icon-search',
  link: 'helpinstall'
}, {
  name: '工程路径配置',
  icon: 'icon-layers',
  link: 'projectpath'
}, {
  name: 'Host 管理',
  icon: 'icon-box',
  link: 'hostfilelist'
}, {
  name: 'Http 转发',
  icon: 'icon-skip',
  link: 'rulefilelist'
}, {
  name: '自定义 mock 数据',
  icon: 'icon-suoding',
  link: 'datalist'
}, {
  name: '请求监控',
  icon: 'icon-bargraph',
  link: '/monitor.html',
  targetBlank: true
}, {
  name: '帮助中心',
  icon: 'icon-security',
  link: 'https://youzan.github.io/zan-proxy/',
  targetBlank: true
}, {
  name: '插件管理',
  icon: 'icon-layers',
  link: 'plugins'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'left-menu',

  data: function data() {
    return {
      defaultActive: this.getDefaultActive(),
      menuList: menuList
    };
  },


  methods: {
    getDefaultActive: function getDefaultActive() {
      var _location = location,
          hash = _location.hash;

      var defaultActive = '';
      menuList.forEach(function (item, index1) {
        if (Array.isArray(item)) {} else if (hash.indexOf(item.link) !== -1) {
          defaultActive = index1 + '';
        }
      });

      return defaultActive;
    },
    handleSelect: function handleSelect(key, keyPath) {
      var item = {};
      if (keyPath.length == 2) {
        var indexarray = keyPath[1].split('-');
        item = this.menuList[indexarray[0]]['children'][indexarray[1]];
      } else {
        item = this.menuList[parseInt(key)];
      }

      if (item.targetBlank) {
        window.open(item['link']);
      } else {
        this.$router.push(item['link']);
      }
    }
  }
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_profile__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forEach__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-path',

  methods: {
    deleteParam: function deleteParam(row, index, list) {
      var _this = this;

      this.$confirm('此操作不可恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$dc.projectPathArray.splice(index, 1);
      });
    },
    saveFile: function saveFile() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var projectPathMap, projectNames, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, k, response, serverData;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                projectPathMap = {};

                __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(_this2.$dc.projectPathArray, function (obj) {
                  projectPathMap[obj.key] = obj.value;
                });
                projectNames = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(projectPathMap);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 6;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(projectNames);

              case 8:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 16;
                  break;
                }

                k = _step.value;

                if (!k.includes('-')) {
                  _context.next = 13;
                  break;
                }

                _this2.$message.error('\u5DE5\u7A0B\u540D' + k + '\u5305\u542B\u975E\u6CD5\u5B57\u7B26"-"');
                return _context.abrupt('return');

              case 13:
                _iteratorNormalCompletion = true;
                _context.next = 8;
                break;

              case 16:
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 22:
                _context.prev = 22;
                _context.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 25:
                _context.prev = 25;

                if (!_didIteratorError) {
                  _context.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context.finish(25);

              case 29:
                return _context.finish(22);

              case 30:
                _this2.$dc.profile.projectPath = projectPathMap;
                _context.next = 33;
                return __WEBPACK_IMPORTED_MODULE_4__api_profile__["a" /* default */].saveFile(_this2.$dc.profile);

              case 33:
                response = _context.sent;
                serverData = response.data;

                if (serverData.code == 0) {
                  _this2.$message({
                    type: 'success',
                    message: '保存成功!'
                  });
                } else {
                  _this2.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                }

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    addParam: function addParam() {
      this.$dc.projectPathArray.push({
        key: '',
        value: ''
      });
    }
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'datalist'
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    var certUrl = 'http://' + location.hostname + ':' + (location.port || 80) + '/utils/rootCA.crt';
    return {
      url: certUrl,
      imgUrl: __WEBPACK_IMPORTED_MODULE_0_qrcode_js___default.a.toDataURL(certUrl, 4)
    };
  }
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_host__ = __webpack_require__(35);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            createFileForm: {
                name: '',
                description: ''
            },
            rules: {
                name: [{ required: true, message: '请输入文件名称名称', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
                description: [{ required: true, message: '请填文件描述', trigger: 'blur' }]
            }
        };
    },

    methods: {
        submitForm: function submitForm(formName) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    __WEBPACK_IMPORTED_MODULE_0__api_host__["a" /* default */].createFile(_this.createFileForm.name, _this.createFileForm.description).then(function (response) {
                        var serverData = response.data;
                        if (serverData.code == 0) {
                            _this.$message({
                                message: '恭喜你，创建成功',
                                type: 'success'
                            });
                            _this.$router.push('edithost?name=' + _this.createFileForm.name);
                        } else {
                            _this.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        back: function back() {
            this.$router.push('hostfilelist');
        }
    }
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_host__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            loaded: false,
            filecontent: {},
            hostarray: []
        };
    },

    methods: {
        getFile: function getFile() {
            var _this = this;

            this.loaded = false;
            __WEBPACK_IMPORTED_MODULE_0__api_host__["a" /* default */].getFileContent(this.$route.query.name).then(function (response) {
                var serverData = response.data;
                if (serverData.code == 0) {
                    _this.loaded = true;
                    _this.filecontent = serverData.data;

                    _this.hostarray = [];
                    __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(_this.filecontent.content, function (value, key) {
                        _this.hostarray.push({
                            key: key,
                            value: value
                        });
                    });
                } else {
                    _this.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                }
            });
        },
        onDeleteRow: function onDeleteRow(row, index, list) {
            var _this2 = this;

            this.$confirm('此操作不可恢复, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.hostarray.splice(index, 1);
            });
        },
        saveFile: function saveFile() {
            var _this3 = this;

            var content = {};
            __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(this.hostarray, function (obj) {
                content[obj.key] = obj.value;
            });
            this.filecontent.content = content;

            __WEBPACK_IMPORTED_MODULE_0__api_host__["a" /* default */].saveFile(this.$route.query.name, this.filecontent).then(function (response) {
                var serverData = response.data;
                if (serverData.code == 0) {
                    _this3.$message({
                        type: 'success',
                        message: '保存成功!'
                    });
                } else {
                    _this3.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                }
            });
        },
        addRow: function addRow() {
            this.hostarray.unshift({
                key: "",
                value: ""
            });
        }
    },
    mounted: function mounted() {
        this.getFile();
    },

    watch: {
        '$route': function $route(to, from) {
            this.getFile();
        }
    }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_host__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hostlist',
  methods: {
    onDeleteFile: function onDeleteFile(row, index, list) {
      var _this = this;

      this.$confirm('\u6B64\u64CD\u4F5C\u5C06\u6C38\u4E45\u5220\u9664\u8BE5\u6587\u4EF6: ' + row.name + ', \u662F\u5426\u7EE7\u7EED?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2__api_host__["a" /* default */].deleteFile(row.name).then(function (response) {
          var serverData = response.data;
          if (serverData.code == 0) {
            _this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            _this.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
          }
        });
      });
    },
    toggleFile: function toggleFile(name) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_host__["a" /* default */].debouncedUseFile(name, function (response) {
        var serverData = response.data;
        if (serverData.code == 0) {
          _this2.$message({
            type: 'success',
            message: '设置成功!'
          });
        } else {
          _this2.$message.error('\u51FA\u9519\u4E86,\u8BF7\u5237\u65B0\u9875\u9762\uFF0C' + serverData.msg);
        }
      });
    },
    addNewHostFile: function addNewHostFile() {
      this.$router.push('createhostfile');
    },
    importHostFileBtnClick: function importHostFileBtnClick() {
      this.$refs.fileimport.click();
    },
    importHostFile: function importHostFile(evt) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var fileStr = e.target.result;
        var hostFile = JSON.parse(fileStr);
        hostFile.checked = false;
        __WEBPACK_IMPORTED_MODULE_2__api_host__["a" /* default */].saveFile(hostFile.name, hostFile);
      };
      var files = evt.target.files;
      var file = files[0];
      if (!file) return;
      reader.readAsText(file);
    },
    importRemoteHostFile: function importRemoteHostFile() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, url, response, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$prompt('请输入远程Host文件的url', '导入远程Host文件', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                });

              case 2:
                result = _context.sent;
                url = result.value;
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2__api_host__["a" /* default */].importRemote(url);

              case 7:
                response = _context.sent;
                res = response.data;

                if (!(res.code !== 0)) {
                  _context.next = 11;
                  break;
                }

                throw res.msg;

              case 11:
                _this3.$message({
                  message: '导入成功',
                  type: 'success'
                });
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](4);

                _this3.$message.error('\u51FA\u9519\u4E86, ' + _context.t0);

              case 17:
                return _context.abrupt('return');

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[4, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    add: Function
  },
  data: function data() {
    return {
      dialogVisible: false,
      plugin: {
        name: '',
        registry: ''
      },
      formLabelWidth: '120px'
    };
  },

  methods: {
    hideDialog: function hideDialog(e) {
      if (this.dialogVisible) {
        e.stopPropagation();
        this.dialogVisible = false;
      }
    },
    showDialog: function showDialog(e) {
      if (!this.dialogVisible) {
        this.plugin.name = '';
        this.plugin.registry = '';
        this.dialogVisible = true;
      }
    },
    onConfirm: function onConfirm(e) {
      var _this = this;

      var _plugin = this.plugin,
          name = _plugin.name,
          registry = _plugin.registry;

      if (!name) {
        this.$message.error('请填写包名');
        return;
      }
      this.add(name, registry).then(function () {
        return _this.hideDialog(e);
      });
    },
    handleClose: function handleClose(done) {
      setTimeout(function (_) {
        return done();
      }, 0);
    }
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'plugin',
  props: {
    plugin: Object,
    delete: Function,
    setDisabled: Function
  },
  data: function data() {
    return {
      isDeleted: false
    };
  },

  methods: {
    toPlugin: function toPlugin() {
      window.open('./plugins/' + this.plugin.name + '/', '_blank');
    },
    onDelete: function onDelete(e) {
      e.stopPropagation();
      this.delete(this.plugin.name);
    },
    onSetDisabled: function onSetDisabled(command) {
      this.setDisabled(this.plugin.name, command);
    }
  },
  computed: {
    disabledText: function disabledText() {
      if (this.plugin.disabled) {
        return '已禁用';
      }
      return '已启用';
    }
  }
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Plugin__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Add__ = __webpack_require__(381);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manager',
  data: function data() {
    return {
      plugins: []
    };
  },

  components: {
    'plugin': __WEBPACK_IMPORTED_MODULE_3__Plugin__["a" /* default */],
    'add': __WEBPACK_IMPORTED_MODULE_4__Add__["a" /* default */]
  },
  methods: {
    fetch: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function () {
      var _this = this;

      fetch('./plugins/list').then(function (res) {
        return res.json();
      }).then(function (res) {
        _this.plugins = res.data.map(function (p) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(p, { url: './' + p.name + '/' });
        });
      });
    }),
    deletePlugin: function deletePlugin(name) {
      var _this2 = this;

      var loading = this.$loading({
        lock: true,
        text: '删除中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return fetch('./plugins/remove', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ name: name })
      }).then(function (res) {
        loading.close();
        if (res.status !== 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('server error');
        }
        _this2.$message({
          message: '删除成功，重启后生效',
          type: 'success'
        });
        _this2.fetch();
      }).catch(function (e) {
        loading.close();
        _this2.$message.error('删除失败，请重试');
      });
    },
    addPlugin: function addPlugin(name, registry) {
      var _this3 = this;

      var loading = this.$loading({
        lock: true,
        text: '添加中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return fetch('./plugins/add', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ name: name, registry: registry })
      }).then(function (res) {
        loading.close();
        if (res.status !== 200) {
          res.text().then(function (message) {
            _this3.$message({
              message: message,
              type: 'error'
            });
          });
          return;
        }
        _this3.$message({
          message: '添加成功，重启后生效',
          type: 'success'
        });
        _this3.fetch();
      }).catch(function (e) {
        loading.close();
        _this3.$message.error('添加失败，请重试');
      });
    },
    setPluginDisabled: function setPluginDisabled(name, disabled) {
      var _this4 = this;

      var loading = this.$loading({
        lock: true,
        text: '设置中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return fetch('./plugins/disabled', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ name: name, disabled: disabled })
      }).then(function (res) {
        loading.close();
        if (res.status !== 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('server error');
        }
        _this4.$message({
          message: '设置成功，重启后生效',
          type: 'success'
        });
        _this4.fetch();
      }).catch(function (e) {
        loading.close();
        _this4.$message.error('设置失败，请重试');
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'action-detail',
    props: ['action', 'remote'],
    data: function data() {
        return {
            ruleType: [{ value: 'redirect', label: '转发请求' }, { value: 'mockData', label: '返回自定义数据' }, { value: 'addRequestHeader', label: '增加请求头' }, { value: 'addResponseHeader', label: '增加响应头' }, { value: 'empty', label: '返回空文件' }],
            modifyResponseType: [{ value: 'addTimestampToJsCss', label: '将html中的js、css请求加上时间戳' }, { value: 'returnDataInJsonpStyle', label: '以JSONP的方式返回数据' }, { value: 'allowCros', label: '增加跨域头部' }, { value: 'return404', label: '返回404' }]
        };
    },

    methods: {
        addDataFile: function addDataFile() {
            var _this = this;

            this.$dc.requestAddDataFile(function (id) {
                _this.action.data.dataId = id;
            });
        },
        editDataFile: function editDataFile(entry) {
            this.$dc.requestEditDataFile(entry);
        }
    },
    computed: {
        datafileEntry: function datafileEntry() {
            var _this2 = this;

            if (this.action.type == "mockData") {
                var finded = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.$dc.dataList, function (entry) {
                    return entry.id == _this2.action.data.dataId;
                });
                if (!finded) this.action.data.dataId = '';
                return finded;
            }
        }
    }
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_rule__ = __webpack_require__(36);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            createFileForm: {
                name: '',
                checked: true,
                description: ''
            },
            rules: {
                name: [{ required: true, message: '请输入文件名称名称', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 20 个字符', trigger: 'blur' }],
                description: [{ required: true, message: '请填文件描述', trigger: 'blur' }]
            }
        };
    },

    methods: {
        submitForm: function submitForm(formName) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    __WEBPACK_IMPORTED_MODULE_0__api_rule__["a" /* default */].createFile(_this.createFileForm.name, _this.createFileForm.description).then(function (response) {
                        var serverData = response.data;
                        if (serverData.code == 0) {
                            _this.$message({
                                message: '恭喜你，创建成功',
                                type: 'success'
                            });
                            _this.$router.push('editrule?name=' + _this.createFileForm.name);
                        } else {
                            _this.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        back: function back() {
            this.$router.push('rulefilelist');
        }
    }
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_rule__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RuleDetail__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditRuleDialog__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EditRuleConfigDialog_vue__ = __webpack_require__(386);












__WEBPACK_IMPORTED_MODULE_6_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5__RuleDetail__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__RuleDetail__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-rule',
  components: {
    'edit-dialog': __WEBPACK_IMPORTED_MODULE_7__EditRuleDialog__["a" /* default */],
    'edit-rule-config-dialog': __WEBPACK_IMPORTED_MODULE_8__EditRuleConfigDialog_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loaded: false,
      name: '',
      filecontent: { meta: {} },
      testMatchRuleFormVisible: false,
      testMatchRuleForm: {
        url: '',
        match: '',
        targetTpl: '',
        matchRlt: '',
        targetRlt: '',
        msg: ''
      },
      dialogVisible: false,
      editRuleConfigDialogVisible: false,
      editRuleKey: null
    };
  },

  methods: {
    getFile: function getFile() {
      var _this = this;

      this.loaded = false;
      this.name = this.$route.query.name;
      __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].getFileContent(this.$route.query.name).then(function (response) {
        var serverData = response.data;
        if (serverData.code == 0) {
          _this.loaded = true;

          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(serverData.data.content, function (rule) {
            rule.key = rule.key || __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()();
          });

          if (_this.$dc.dataList.length > 0) {
            _this.filecontent = serverData.data;
          } else {
            setTimeout(function () {
              _this.filecontent = serverData.data;
            }, 1000);
          }
        } else {
          _this.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
        }
      }).catch(function (error) {
        _this.filecontent = {
          meta: {},
          "content": []
        };
      });
    },
    onDeleteRow: function onDeleteRow(row, index, list) {
      var _this2 = this;

      this.$confirm('此操作不可恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.filecontent.content.splice(index, 1);
        _this2.saveFileRightNow();
      });
    },
    onDuplicateRow: function onDuplicateRow(row, index, list) {
      var copy = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.filecontent.content[index]);
      copy.key = __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()();
      this.filecontent.content.splice(index, 0, copy);
      this.saveFileRightNow();
    },
    saveFileRightNow: function saveFileRightNow() {
      this.saveFile();
      __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].debouncedSaveFile.flush();
    },
    saveFile: function saveFile(donotalert) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].debouncedSaveFile(this.name, this.filecontent, function (response) {
        var serverData = response.data;
        if (serverData.code == 0) {
          if (!donotalert) {
            _this3.$message({
              type: 'success',
              message: '保存成功!'
            });
          }
          _this3.getFile();
        } else {
          _this3.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
        }
      });
    },
    addRule: function addRule() {
      this.editRuleKey = null;

      this.dialogVisible = true;
    },
    testMatchRuleRequest: function testMatchRuleRequest(row) {
      this.testMatchRuleForm.match = row.match;
      this.testMatchRuleForm.targetTpl = row.actionList[0] && row.actionList[0].data.target || '';
      this.testMatchRuleForm.url = '';
      this.testMatchRuleForm.matchRlt = '';
      this.testMatchRuleForm.targetRlt = '';
      this.testMatchRuleForm.msg = '';
      this.testMatchRuleFormVisible = true;
    },
    testMatchRule: function testMatchRule() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].testRule(this.testMatchRuleForm).then(function (response) {
        var serverData = response.data;
        if (serverData.code == 0) {
          _this4.testMatchRuleForm.matchRlt = serverData.data.matchRlt;
          _this4.testMatchRuleForm.targetRlt = serverData.data.targetRlt;
          _this4.testMatchRuleForm.msg = serverData.data.msg;
        }
      });
    },
    dialogEdit: function dialogEdit(key) {
      this.editRuleKey = key;
      this.dialogVisible = true;
    },
    hideEditDialog: function hideEditDialog() {
      this.dialogVisible = false;
    },
    dialogSave: function dialogSave(rule) {
      var rules = this.filecontent.content || [];
      var index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(rules, function (r) {
        return r.key === rule.key;
      });
      if (index >= 0) {
        rules[index] = rule;
      } else {
        rules.unshift(rule);
      }
      this.filecontent.content = rules;
      this.hideEditDialog();
      this.saveFileRightNow();
    },
    openEditRuleInfoDialog: function openEditRuleInfoDialog() {
      this.editRuleConfigDialogVisible = true;
    },
    closeEditRuleNameDialog: function closeEditRuleNameDialog() {
      this.editRuleConfigDialogVisible = false;
    },
    updateFileInfo: function updateFileInfo(newName, newDescription) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var errMessage, _ref, status, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                errMessage = '';

                if (!(newName === '')) {
                  _context.next = 5;
                  break;
                }

                errMessage = '规则集名称不能为空!';
                _context.next = 11;
                break;

              case 5:
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].updateFileInfo(_this5.filecontent.name, {
                  name: newName,
                  description: newDescription
                });

              case 7:
                _ref = _context.sent;
                status = _ref.status;
                data = _ref.data;

                if (status !== 200) {
                  errMessage = '请求失败';
                } else if (data.code !== 0) {
                  errMessage = data.msg;
                }

              case 11:

                if (errMessage) {
                  _this5.$message({
                    type: 'error',
                    message: errMessage
                  });
                } else {
                  _this5.filecontent.name = newName;
                  _this5.editRuleConfigDialogVisible = false;
                  _this5.$router.replace('editrule?name=' + newName);
                  _this5.$message({
                    type: 'success',
                    message: '修改规则集名称成功!'
                  });
                }

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    onMoveUpRule: function onMoveUpRule(index) {
      if (index === 0) {
        return;
      }
      var rules = this.filecontent.content || [];
      if (rules.length < 2 || index >= rules.length) {
        return;
      }
      var temp = rules[index];
      rules[index] = rules[index - 1];
      rules[index - 1] = temp;
      this.filecontent.content = rules;
      this.saveFileRightNow();
    }
  },
  mounted: function mounted() {
    this.getFile();
  },

  watch: {
    '$route': function $route(to, from) {
      this.getFile();
    }
  },
  computed: {
    editingRule: function editingRule() {
      var _this6 = this;

      var rules = this.filecontent.content || [];
      return rules.filter(function (rule) {
        return rule.key === _this6.editRuleKey;
      })[0] || null;
    }
  }
});

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'edit-rule-name-dialog',
    data: function data() {
        return {
            name: '',
            description: ''
        };
    },

    props: {
        visible: Boolean,
        ok: Function,
        cancel: Function,
        defaultName: {
            type: String,
            default: ''
        },
        defaultDescription: {
            type: String,
            default: ''
        }
    },
    watch: {
        defaultName: function defaultName(value) {
            this.name = value;
        },
        defaultDescription: function defaultDescription(value) {
            this.description = value;
        }
    },
    computed: {
        dialogVisible: {
            get: function get() {
                return this.visible;
            },
            set: function set(val) {
                if (!val) {
                    this.cancel();
                }
            }
        }
    }
});

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionDetail__ = __webpack_require__(160);






function newRule() {
    var defaultRule = {
        method: '',
        match: '',
        name: '',
        checked: true,
        actionList: [{
            type: 'redirect',
            data: {
                target: '',
                dataId: '',
                modifyResponseType: '',
                callbackName: "",
                cookieKey: "",
                cookieValue: "",
                headerKey: "",
                headerValue: "",
                modifyRequestScript: "",
                modifyResponseScript: ""
            }
        }]
    };
    defaultRule.key = __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()();
    return defaultRule;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'edit-rule-dialog',
    components: {
        'action-detail': __WEBPACK_IMPORTED_MODULE_2__ActionDetail__["a" /* default */]
    },
    data: function data() {
        var roleToClone = this.initRule || newRule;
        return {
            rule: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(roleToClone),
            formLabelWidth: '80px',
            methodlist: [{ value: '', label: '所有' }, { value: 'get', label: 'GET' }, { value: 'post', label: 'POST' }, { value: 'put', label: 'PUT' }, { value: 'patch', label: 'PATCH' }, { value: 'delete', label: 'DELETE' }]
        };
    },

    methods: {
        addAction: function addAction() {
            this.rule.actionList.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(newRule().actionList[0]));
        },
        removeAction: function removeAction(index) {
            this.rule.actionList.splice(index, 1);
            if (!this.rule.actionList.length) {
                this.addAction();
            }
        },
        saveRule: function saveRule() {
            this.save(this.rule);
        }
    },
    props: {
        visible: Boolean,
        initRule: Object,
        save: Function,
        cancel: Function
    },
    watch: {
        visible: function visible(val) {
            if (val) {
                var ruleToClone = this.initRule || newRule();
                this.rule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(ruleToClone);
            }
        }
    },
    computed: {
        dialogVisible: {
            get: function get() {
                return this.visible;
            },
            set: function set(val) {
                if (!val) {
                    this.cancel();
                }
            }
        }
    }
});

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_rule__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_utils__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rulefilelist',
  methods: {
    onDeleteFile: function onDeleteFile(row, index) {
      var _this2 = this;

      this.$confirm('\u6B64\u64CD\u4F5C\u5C06\u6C38\u4E45\u5220\u9664\u8BE5\u6587\u4EF6: ' + row.name + ', \u662F\u5426\u7EE7\u7EED?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].deleteFile(row.name).then(function (response) {
          var serverData = response.data;
          if (serverData.code == 0) {
            _this2.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            _this2.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
          }
        });
      });
    },
    onShareFile: function onShareFile(row, index) {
      if (row.meta && !row.meta.remote) {
        window.location = '/rule/download?name=' + row.name;
      } else {
        this.$alert(row.meta.url, '规则URL', {
          confirmButtonText: 'OK',
          callback: function callback(action) {}
        });
      }
    },
    onCopyFile: function onCopyFile(row, index) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].copyFile(row.name).then(function () {
        _this3.$message({
          type: 'success',
          message: '复制成功!'
        });
      });
    },
    onUpdateFile: function onUpdateFile(row, index) {
      var _this4 = this;

      this.$confirm('\u786E\u5B9A\u66F4\u65B0: ' + row.name + ' \u4E48?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].getRemoteRuleFile(row.meta.url).then(function (response) {
          var remoteFileResponse = response.data;
          var content = remoteFileResponse.data;
          content.meta = {
            remote: true,
            url: row.meta.url,
            ETag: remoteFileResponse.headers['etag'],
            remoteETag: remoteFileResponse.headers['etag']
          };
          content.name = content.name + '-remote';
          __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].saveFile(content.name, content).then(function (response) {
            var serverData = response.data;
            if (serverData.code == 0) {
              _this4.$message({
                message: '恭喜你，更新成功',
                type: 'success'
              });
            } else {
              _this.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
            }
          });
        });
      });
    },
    importRemoteRule: function importRemoteRule() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, url, response, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this5.$prompt('请输入远程规则文件的url', '导入远程规则', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                });

              case 2:
                result = _context.sent;
                url = result.value;
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].importRemote(url);

              case 7:
                response = _context.sent;
                res = response.data;

                if (!(res.code !== 0)) {
                  _context.next = 11;
                  break;
                }

                throw res.msg;

              case 11:
                _this5.$message({
                  message: '导入成功',
                  type: 'success'
                });
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](4);

                _this5.$message.error('\u51FA\u9519\u4E86, ' + _context.t0);

              case 17:
                return _context.abrupt('return');

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[4, 14]]);
      }))();
    },
    onSelectionChange: function onSelectionChange(name, checked) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].setFileCheckStatus(name, checked).then(function (response) {
        var serverData = response.data;
        if (serverData.code == 0) {
          _this6.$message({
            type: 'success',
            message: '设置成功!'
          });
        } else {
          _this6.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
        }
      });
    },
    onDisableSyncChange: function onDisableSyncChange(name, checked) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].setFileDisableSync(name, checked).then(function (response) {
        var serverData = response.data;
        if (serverData.code == 0) {
          _this7.$message({
            type: 'success',
            message: '设置成功!'
          });
        } else {
          _this7.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
        }
      });
    },
    addRuleCollection: function addRuleCollection() {
      this.$router.push('createrulefile');
    },
    fileUpload: function fileUpload(evt) {
      var _this = this;
      var files = evt.target.files;
      var file = files[0];
      if (!file) return;

      var reader = new FileReader();
      reader.onload = function (e) {
        var contentStr = e.target.result;
        var content = JSON.parse(contentStr);

        var finded = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(_this.fileList, function (file) {
          return file.name == content.name;
        });
        if (finded) {
          _this.$message.error('\u5DF2\u7ECF\u5B58\u5728\u540D\u4E3A' + content.name + '\u7684\u89C4\u5219\uFF0C\u8BF7\u4FEE\u6539\u89C4\u5219\u6587\u4EF6\u91CC\u7684name\u5B57\u6BB5,\u4EE5\u53CA\u6587\u4EF6\u540D');
          return;
        }

        var varNameList = __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].getReferenceVar(content);
        var infoStr;
        if (varNameList.length > 0) {
          infoStr = '\u5BFC\u5165\u89C4\u5219\u6587\u4EF6\u540D\u4E3A' + content.name + ',\u5F15\u7528\u53D8\u91CF\u3010' + varNameList.join('; ') + '\u3011\u8BF7\u786E\u4FDD\u53D8\u91CF\u5DF2\u7ECF\u5728\u5DE5\u7A0B\u8DEF\u5F84\u914D\u7F6E\u4E2D\u8BBE\u7F6E\u8FC7\u503C';
        } else {
          infoStr = '\u5BFC\u5165\u89C4\u5219\u6587\u4EF6\u540D\u4E3A' + content.name;
        }
        _this.$alert(infoStr, '规则文件导入', {
          confirmButtonText: '确定',
          callback: function callback(action) {
            if (action == 'confirm') {
              __WEBPACK_IMPORTED_MODULE_2__api_rule__["a" /* default */].saveFile(content.name, content).then(function (response) {
                var serverData = response.data;
                if (serverData.code == 0) {
                  _this.$message({
                    message: '恭喜你，导入成功',
                    type: 'success'
                  });
                } else {
                  _this.$message.error('\u51FA\u9519\u4E86\uFF0C' + serverData.msg);
                }
              });
            }
          }
        });
      };
      reader.readAsText(file);
    }
  }
});

/***/ })

},[214]);


// WEBPACK FOOTER //
// static/js/manager.js